import React, { useRef } from 'react';

const FORMATS = [
  { label: 'B', tag: '**', title: 'Bold', style: { fontWeight: 'bold' } },
  { label: 'I', tag: '_', title: 'Italic', style: { fontStyle: 'italic' } },
  { label: 'U', tag: '__', title: 'Underline', style: { textDecoration: 'underline' } },
];

export function RichTextarea({ value, onChange, placeholder, rows = 10 }) {
  const ref = useRef(null);

  const applyFormat = (tag) => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const selected = value.slice(start, end);
    const before = value.slice(0, start);
    const after = value.slice(end);
    const newValue = `${before}${tag}${selected || 'text'}${tag}${after}`;
    onChange(newValue);
    // Restore cursor position after React re-render
    setTimeout(() => {
      el.focus();
      const newPos = start + tag.length + (selected || 'text').length + tag.length;
      el.setSelectionRange(newPos, newPos);
    }, 0);
  };

  return (
    <div className="rich-editor">
      <div className="rich-toolbar">
        {FORMATS.map(f => (
          <button
            key={f.tag}
            type="button"
            title={f.title}
            style={f.style}
            onClick={() => applyFormat(f.tag)}
          >
            {f.label}
          </button>
        ))}
      </div>
      <textarea
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
      />
    </div>
  );
}

// Renders stored markdown-style tags as HTML
export function RichText({ content }) {
  const html = content
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/__(.*?)__/g, '<u>$1</u>')
    .replace(/_(.*?)_/g, '<em>$1</em>');
  return <div className="content-body" dangerouslySetInnerHTML={{ __html: html.replace(/\n/g, '<br/>') }} />;
}
